import { useContext } from 'react';
import { PleriRenderContext } from './PleriRenderContext';

/**
 * Optional version of usePleriRender that doesn't throw if context is not available
 * Returns null if PleriRenderContext is not provided
 *
 * This allows Pleri to work both standalone and within PleriRenderWindow
 */
export const usePleriRenderOptional = () => {
  const context = useContext(PleriRenderContext);
  return context || null;
};
